export default __webpack_public_path__ + "static/media/Banner1.343ab3d6.webp";